import { memo, useCallback, useEffect, useMemo, useState } from 'react'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { Order, PageLoadingSpinner, PrescriptionPopUp, SecondaryButton } from 'ui_kit_qmd'
import cl from 'classnames'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import {
  VIDEO_CALL_NOTES_PRESCRIPTIONS_TITLE_TEXT,
  NO_PRESCRIPTIONS_TEXT,
  NEW_TEXT,
} from '../../../../../utils/constants'
import './PrescriptionsSection.scss'
import plus from '../../../../../images/common/plusIcon.png'
import { getPastVisitTreatLink } from '../../../../../store/charts/ChartsThunk'
import { setPastVisitTreatLink } from '../../../../../store/charts/ChartsActions'
import {
  useGetVisitsVisitIdPrescriptions,
  getGetVisitsVisitIdPrescriptionsQueryKey,
  getVisitsVisitIdEncounterUrl,
} from '../../../../../api/generated/prescription/prescription'
import { mapPrescriptionToLegacy } from '../../../../../utils/prescriptionMapper'
import { ProductOrderPopUp } from '../../../../../components/product-order-popup/ProductOrderPopUp'
import { getProducts } from '../../../../../store/products/productsThunk'
import { ButtonOptionsSelector } from '../../../../../components/button-options-selector/ButtonOptionsSelector'
import { selectDtsMoudPilotEnabled } from '../../../../../store/flags/FlagsSelectors'
import { windowOpenArgs } from 'utils/windowOpenArgs'
import { useSelector } from 'store/hooks/useSelector'
import { useIsProviderScriptSureCohort } from 'hooks/useIsProviderScriptSureCohort'

const PrescriptionsNewBtnContainerStyle = {
  maxHeight: 40,
  width: 88,
  justifyContent: 'center',
}

const PrescriptionsNewBtnImgStyle = {
  height: 16.5,
  width: 16.5,
  marginRight: 8,
}

export const PrescriptionsSection = memo(
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  ({ isNotCompleted, isCancelledStatus, isUpcomingVisit, description, patientId, patientInfo, tabId }) => {
    const location = useLocation()
    const visitId = location.state?.visitId

    const dispatch = useDispatch()
    const queryClient = useQueryClient()

    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    const pastVisitTreatLink = useSelector((state) => state.chartsReducer.pastVisitTreatLink?.[visitId]?.ProfileUrl)
    const flags = useSelector((state) => state.flags.flags)
    const dtsMoudPilotEnabled = useSelector(selectDtsMoudPilotEnabled)
    const isProviderScriptSure = useIsProviderScriptSureCohort()

    const { data: rawPrescriptions = [], isLoading } = useGetVisitsVisitIdPrescriptions(visitId, {
      query: { enabled: !!visitId },
    })

    const prescriptionsList = useMemo(() => rawPrescriptions.map(mapPrescriptionToLegacy), [rawPrescriptions])

    const [prescription, setPrescription] = useState()
    const [isOpenTreatSuccess, setIsOpenTreatSuccess] = useState(false)

    useEffect(() => {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      dispatch(setPastVisitTreatLink())
    }, [])

    const onClickNew = () => {
      if (pastVisitTreatLink) window.open(pastVisitTreatLink, ...windowOpenArgs)
      else {
        setIsOpenTreatSuccess(true)
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        dispatch(getPastVisitTreatLink(visitId))
      }
    }

    const onClickAdd = async () => {
      const response = await getVisitsVisitIdEncounterUrl(visitId)
      const url = response?.ProfileUrl ?? null
      if (url) window.open(url, ...windowOpenArgs)
    }

    const onGetProducts = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (category) => {
        dispatch(getProducts(patientId, category, tabId, patientInfo?.Address?.StateCode))
      },
      [dispatch, patientId, patientInfo?.Address?.StateCode, tabId],
    )
    useEffect(() => {
      if (isOpenTreatSuccess && pastVisitTreatLink) {
        setIsOpenTreatSuccess(false)
        onClickNew()
      }
    }, [isOpenTreatSuccess, pastVisitTreatLink])

    /** @type ButtonOption[] */
    const orderButtonOptions =
      isProviderScriptSure ?
        [
          {
            buttonText: 'Add',
            image: plus,
            imageStyle: PrescriptionsNewBtnImgStyle,
            onPress: onClickAdd,
          },
        ]
      : [
          {
            buttonText: 'Treat',
            image: plus,
            imageStyle: PrescriptionsNewBtnImgStyle,
            onPress: onClickNew,
          },
          ...(flags.product_order_types?.includes('OUD') && dtsMoudPilotEnabled ?
            [
              {
                buttonText: 'OUD',
                image: plus,
                imageStyle: PrescriptionsNewBtnImgStyle,
                onPress: () => {
                  onGetProducts('moud')
                },
              },
            ]
          : []),
          ...(flags.product_order_types?.includes('MHT') ?
            [
              {
                buttonText: 'MHT',
                image: plus,
                imageStyle: PrescriptionsNewBtnImgStyle,
                onPress: () => {
                  onGetProducts('MenopauseHormoneTherapy')
                },
              },
            ]
          : []),
        ]
    return (
      <>
        <ProductOrderPopUp
          patientId={patientId}
          address={
            patientInfo?.Address || {
              StreetAddress1: 'Street address 1',
              StreetAddress2: '',
              City: 'City',
              Zip: 'Zip',
              StateCode: 'CA',
            }
          }
          visitId={visitId}
          tabId={tabId}
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          creditCards={patientInfo?.creditCards}
          getOrders={() => {
            queryClient.invalidateQueries({
              queryKey: getGetVisitsVisitIdPrescriptionsQueryKey(visitId),
            })
          }}
        />
        {prescription ?
          <PrescriptionPopUp
            isProvider
            prescription={prescription}
            onClose={() => {
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              setPrescription(null)
            }}
          />
        : null}
        <div
          className={cl('prescriptions-section-header', {
            'prescriptions-section-header--without-btn': !isNotCompleted,
            'prescriptions-section-header-upcoming-visit': isUpcomingVisit,
          })}>
          <div className='prescriptions-section-text prescriptions-section-title'>
            {VIDEO_CALL_NOTES_PRESCRIPTIONS_TITLE_TEXT}
          </div>
          {isNotCompleted && !isCancelledStatus && !isUpcomingVisit ?
            orderButtonOptions.length > 1 ?
              <ButtonOptionsSelector
                options={orderButtonOptions}
                className='patient-chart-button-option-selector-container'
              />
            : <SecondaryButton
                btnText={isProviderScriptSure ? 'Add' : NEW_TEXT}
                containerStyle={PrescriptionsNewBtnContainerStyle}
                image={plus}
                imageAlt='prescriptionsNewIcon'
                imageStyle={PrescriptionsNewBtnImgStyle}
                onPress={isProviderScriptSure ? onClickAdd : onClickNew}
              />

          : null}
        </div>
        {description ?
          <div className='prescriptions-section-text prescriptions-section-description'>{description}</div>
        : null}
        {isLoading ?
          <PageLoadingSpinner />
        : prescriptionsList?.length ?
          <div className='prescriptions-section-content-list-wrapper'>
            {prescriptionsList.map((item) => (
              <Order
                key={item.PrescriptionId}
                isProvider
                onOpenOrder={() => {
                  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
                  setPrescription({ ...item })
                }}
                order={{ ...item }}
              />
            ))}
          </div>
        : <div className='prescriptions-section-text prescriptions-section-no-prescriptions-tile'>
            {NO_PRESCRIPTIONS_TEXT}
          </div>
        }
        <div className='prescriptions-section-separator' />
      </>
    )
  },
)
